export default "__VITE_ASSET__5dbdab8e__"